import React, { useEffect, useRef } from 'react';

import {
  imgBgCubeSvg,
  imgHeroLogoRotatePosterPng,
  xplaVerticalSvg,
} from '~/assets/images';
import { IcArrowWhiteSvg } from '~/assets/images/icon';

type Props = {};

const Vision: React.FC<Props> = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('suspend', () => {
        if (videoRef.current) {
          videoRef.current?.play();
        }
      });
    }
  }, []);

  return (
    <>
      <section className="hero">
        <div className="contentWrap">
          <div className="topMessage l-txt">
            <span>MetaMagnet</span>&nbsp;will give you an entirely new
            experience in gaming through a content-driven Layer1
            blockchain&nbsp;<span>‘XPLA’.</span>
          </div>
          <video
            ref={videoRef}
            className="logoRotate"
            muted
            autoPlay
            loop
            playsInline
            poster={imgHeroLogoRotatePosterPng}
          >
            <source src="/videos/img-heroLogoRotate.webm" type="video/webm" />
            <source src="/videos/img-heroLogoRotate.mp4" type="video/mp4" />
          </video>
        </div>
      </section>
      <section className="goXpla">
        <img src={xplaVerticalSvg} alt="" className="logo-xpla" />
        <p>
          XPLA is a powerful hub mainnet for diverse content,
          <br />
          providing Web3 games, gaming platforms, NFT marketplaces, and
          metaverse projects.
        </p>
        <a href="https://www.xpla.io/" target="_blank" rel="noreferrer">
          <span> Visit XPLA to learn more </span>
          <img src={IcArrowWhiteSvg} alt="" />
        </a>
      </section>

      <section className="vision" id="vision">
        <div className="contentWrap">
          <div
            className="titleWrap"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <h3 className="xl-txt sectionTitle">Our vision</h3>
            <p className="m-txt">
              To provide the ultimate gaming blockchain infrastructure
              <br />
              where anyone can participate by BUILDING, PLAYING, and OWNING
              content
              <br />
              within the XPLA ecosystem.
            </p>
          </div>
          <div className="visionImg">
            <div className="cubeGroup">
              <img src={imgBgCubeSvg} alt="" />
              <img src={imgBgCubeSvg} alt="" />
            </div>
            <div className="visionCircle m-txt">
              XPLA
              <br />
              Universal Content
              <br />
              Powerhouse
            </div>
            <div className="cubeGroup">
              <img src={imgBgCubeSvg} alt="" />
              <img src={imgBgCubeSvg} alt="" />
              <img src={imgBgCubeSvg} alt="" />
            </div>
          </div>
          <ul className="visionItemWrap">
            <li
              className="visionItem"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div className="cubeContainer">
                <div className="scene">
                  <div className="webpack-cube">
                    <div className="inner-cube">
                      <div className="face face-top" />
                      <div className="face face-bottom" />
                      <div className="face face-left" />
                      <div className="face face-right" />
                      <div className="face face-front" />
                      <div className="face face-back" />
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="s-txt">Content Optimized</h5>
              <p className="xs-txt">
                Proficient in gaming, powered by the Global Gaming Giant, Com2uS
              </p>
            </li>
            <li
              className="visionItem"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div className="cubeContainer">
                <div className="scene">
                  <div className="webpack-cube">
                    <div className="inner-cube">
                      <div className="face face2 face-top" />
                      <div className="face face2 face-bottom" />
                      <div className="face face2 face-left" />
                      <div className="face face2 face-right" />
                      <div className="face face2 face-front" />
                      <div className="face face2 face-back" />
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="s-txt">High Flexibility</h5>
              <p className="xs-txt">
                Compatible with EVM & IBC Protocol, utilizing Cosmos technology
              </p>
            </li>
            <li
              className="visionItem"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div className="cubeContainer">
                <div className="scene">
                  <div className="webpack-cube">
                    <div className="inner-cube">
                      <div className="face face3 face-top" />
                      <div className="face face3 face-bottom" />
                      <div className="face face3 face-left" />
                      <div className="face face3 face-right" />
                      <div className="face face3 face-front" />
                      <div className="face face3 face-back" />
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="s-txt">Versatile Partners</h5>
              <p className="xs-txt">
                100+ Partners reinforce the credibility & potential of XPLA
              </p>
            </li>
            <li
              className="visionItem"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div className="cubeContainer">
                <div className="scene">
                  <div className="webpack-cube">
                    <div className="inner-cube">
                      <div className="face face4 face-top" />
                      <div className="face face4 face-bottom" />
                      <div className="face face4 face-left" />
                      <div className="face face4 face-right" />
                      <div className="face face4 face-front" />
                      <div className="face face4 face-back" />
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="s-txt">Robust Security</h5>
              <p className="xs-txt">
                Audited by CERTIK, trusted by hundreds of thousands of community
                members
              </p>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default Vision;
